import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { RELATED_LINKS_BASE_CLASSNAME } from './Constants';
import { createRelatedLinks } from './RelatedLinks';
createComponents(".".concat(RELATED_LINKS_BASE_CLASSNAME), createRelatedLinks, NO_PATTERN_BUSINESS_LOGIC);
